import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import React from "react";
import styles from "../../styles/pages/editors.module.scss";
// import assest from "@/json/assest";
import assest from "../../json/assest";

import RequestMessageIcon from "../../ui/Icons/RequestMessageIcon";
import CheckSharpIcon from "../../ui/Icons/CheckSharpIcon";

const TipaltiPartnerCard = (userdata) => {

  return (
    <>
      <Paper
        className={`${styles.partnerPaper} ${styles.partnerPaperforPartner}`}
      >
        <figure>
          <img src={assest.tipalti} width={78} height={40} alt="icon" />
        </figure>
        {/* <Typography variant="body1">
          Partner's Tipalti account is not set yet.
        </Typography> */}
        <Typography variant="body1">
          Partner is eligible to receive payments.
        </Typography>
        <Stack
          direction={"row"}
          alignItems={"center"}
          flexWrap={"wrap"}
          className={styles.partnerBtnGrp}
        >
          {/* <Button
            startIcon={<RequestMessageIcon />}
            className={styles.reqstbtn}
            >
            Request Access
          </Button> */}
          {/* <Button startIcon={<CheckSharpIcon />} className={styles.activebtn}>ACTIVE</Button> */}

          {userdata?.userdata?.status === 1 ? (
            <Button startIcon={<CheckSharpIcon />} className={styles.activebtn}>
              ACTIVE
            </Button>
          ) : userdata?.userdata?.status === 0 ? (
            <Button className={styles.inactivebtn}>INACTIVE</Button>
          ) : null}
        </Stack>
      </Paper>
    </>
  );
};

export default TipaltiPartnerCard;
